__turbopack_context__.v({
  "className": "cormorant_ee0693f7-module__ITo7Sa__className",
  "variable": "cormorant_ee0693f7-module__ITo7Sa__variable",
});
